// extracted by mini-css-extract-plugin
export var actions = "_ks-g";
export var benefitCard = "_ks-b";
export var benefitIcon = "_ks-d";
export var benefitLabel = "_ks-f";
export var benefits = "_ks-a";
export var benefitsSection = "_ks-8";
export var bodyText = "_ks-7";
export var closeButton = "_ks-2";
export var content = "_ks-3";
export var eyebrow = "_ks-4";
export var heading = "_ks-5";
export var image = "_ks-i";
export var imagePanel = "_ks-h";
export var modal = "_ks-0";
export var offerCard = "_ks-c";
export var offerIcon = "_ks-e";
export var sectionLabel = "_ks-9";
export var shell = "_ks-1";
export var title = "_ks-6";